import React, { useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import classNames from 'classnames';
//Facade
import Facade from 'core/Facade';
//Stores & Actions
import ControlTowerStore from 'stores/ControlTowerStore';
import AccountStore from 'stores/AccountStore';
import LoggedUserStore from 'stores/LoggedUserStore';
import AccountAction from 'actions/AccountAction';
import ControlTowerAction from 'actions/ControlTowerAction';
import AlertAction from 'actions/AlertAction';
// PCP Components
import ControlTowerTable from 'components/tables/ControlTowerTable/ControlTowerTable';
import Paginator from 'components/commons/Paginator/Paginator';
import { categories } from 'components/page/ControlTowerPage/ControlTowerConstants';
// Material components
import {
    IconButton,
    TableFooter,
    TablePagination,
    TableRow,
    Table,
    AppBar,
    InputLabel,
    MenuItem,
    FormControl,
    Select,
    FormControlLabel,
    Switch,
    CircularProgress,
    Typography,
    Paper,
    Tabs,
    Tab,
    Tooltip
} from '@mui/material';
import Popover from '@mui/material/Popover';
import {
    FlashOn as FlashOnIcon,
    Feedback as FeedbackIcon,
    KeyboardArrowDown as DownIcon,
    KeyboardArrowRight as RightIcon,
} from '@mui/icons-material/';
//Styles
import useStyles from 'components/page/ControlTowerPage/ControlTowerPage.style';
//Translate
import translate from 'locales/i18n';

const ControlTowerPage = () => {

    const [selectedSite, setSelectedSite] = useState('');
    const [selectedAccount, setSelectedAccount] = useState('');

    const [pendingOnly, setPendingOnly] = useState(false);
    const [displayDoneRow, setDisplayDoneRow] = useState(true);
    const [isLoading, setIsLoading] = useState(ControlTowerStore.isLoading());

    const [sites, setSites] = useState(ControlTowerStore.getData() ? ControlTowerStore.getData().sites : null);
    const [stats, setStats] = useState(ControlTowerStore.getStats());
    const [accounts, setAccounts] = useState(AccountStore.getAccounts());

    const [pageParams, setPageParams] = useState({
        category: parseInt(Facade.getUrlParam('category')) ? parseInt(Facade.getUrlParam('category')) : 1,
        rowsPerPage: parseInt(Facade.getUrlParam('rowsPerPage')) ? parseInt(Facade.getUrlParam('rowsPerPage')) : 25
    });
    const [page, setPage] = useState(1);

    const [count, setCount] = useState();

    const classes = useStyles();

    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSite, setCurrentSite] = useState('');

    const tablesRef = useRef();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setCurrentSite('');
    };

    const open = (siteName) => Boolean(anchorEl) && siteName === currentSite;

    useEffect(() => {
        ControlTowerStore.addChangeListener(controlTowerStoreChange);
        AccountStore.addChangeListener(accountStoreChange);
        return () => {
            ControlTowerStore.removeChangeListener(controlTowerStoreChange);
            AccountStore.removeChangeListener(accountStoreChange);
        };
    }, []);

    useEffect(() => {
        ControlTowerAction.getData({ category: categories[pageParams.category].apiName, selectedAccount, selectedSite, pendingOnly, page, rowsPerPage: pageParams.rowsPerPage, bot: 'robot_v3' });
    }, [pageParams, selectedAccount, selectedSite, pendingOnly, page]);

    useEffect(() => {
        AccountAction.getAccounts();
    }, []);

    useEffect(() => {
        stats && setCount(stats.global[categories[pageParams.category].apiName]);
    }, [pageParams.category, stats]);

    useEffect(() => {
        tablesRef.current? tablesRef.current.scrollTop = 0:null;
    },[page, pageParams.category]);

    const controlTowerStoreChange = () => {
        setSites(ControlTowerStore.getData() ? ControlTowerStore.getData().sites : null);
        setStats(ControlTowerStore.getStats());
        setIsLoading(ControlTowerStore.isLoading());
    };

    const accountStoreChange = () => {
        setAccounts(AccountStore.getAccounts());
    };

    const handleChangePageParams = (param, value) => {
        setPageParams({ ...pageParams, [param]: value });
        Facade.setUrlParam(param, value.toString());
    };

    const toggleHide = (id) => {
        const newSites = sites.slice();
        newSites.forEach((site) => {
            if (site.id === id) site.hide = !site.hide;
        });
        setSites(newSites);
    };

    const changeAction = (action, ids, siteId, clickAllItems, params) => {
        ControlTowerAction.changeAction(action,
            ids,
            siteId,
            clickAllItems,
            'robot_v3',
            categories[pageParams.category].apiName.toUpperCase(),
            params
        ).then(res => !res && AlertAction.open('error','Erreur de saisie, le prix n\'a pas été mis à jour ', 'top-right'));
    };

    if (!LoggedUserStore.isLogged()) {
        return (
            <Redirect to='/login' />
        );
    }

    if (!stats)
        return (
            <div className={classes.loadingContainer}>
                <CircularProgress />
            </div>
        );

    return (
        <div className={classes.contentRoot}>
            <Paper className={classes.paper}>
                <div className={classes.filtersBar}>
                    <FormControl classes={{ root: classes.formControlMode }}>
                        <InputLabel>{translate.i18n('SITES')}</InputLabel>
                        <Select
                            value={selectedSite}
                            label='Site'
                            onChange={event => setSelectedSite(event.target.value)}>
                            <MenuItem value={''}>None</MenuItem>
                            {stats.sites.map(site => <MenuItem value={site.id} key={site.id}>{site.name}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <FormControl classes={{ root: classes.formControlMode }}>
                        <InputLabel> {translate.i18n('ACCOUNTS')} </InputLabel>
                        <Select
                            value={selectedAccount}
                            label='Compte'
                            onChange={event => setSelectedAccount(event.target.value)}>
                            <MenuItem value={''}>None</MenuItem>
                            {accounts.map(account => <MenuItem value={account.id} key={account.id}>{account.name}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <div style={{ marginLeft: '20px' }}>
                        Total : {stats.global.total}
                    </div>
                    <FormControlLabel
                        style={{ marginLeft: 'auto' }}
                        control={
                            <Switch
                                checked={displayDoneRow}
                                onChange={() => setDisplayDoneRow(!displayDoneRow)}
                                name='displayDoneRow'
                                color='primary'
                            />
                        }
                        label={translate.i18n('DISPLAY_DONE_ROW')}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={pendingOnly}
                                onChange={() => setPendingOnly(!pendingOnly)}
                                name='pendingOnly'
                                color='primary'
                            />
                        }
                        label={translate.i18n('DISPLAY_PENDING_ONLY')}
                    />
                </div>
                <AppBar position='static' color='default'>
                    <Tabs
                        value={pageParams.category}
                        onChange={(event, newValue) => {
                            handleChangePageParams('category', newValue);
                            setPage(1);
                        }}
                        classes={{
                            flexContainer: classes.tabs
                        }}
                        indicatorColor='primary'
                        textColor='primary'
                        variant='scrollable'
                        scrollButtons='auto'
                    >
                        {categories.map((tab, key) => {
                            const percentage = stats.global.total !== 0 ? (stats.global[tab.apiName] / stats.global.total) * 100 : 0;
                            return <Tab label={<div title={stats.global[tab.apiName] + ' items'}>{tab.name + ' (' + percentage.toFixed(2) + '%)'}</div>} key={key} className={classes.tabCategory} />;
                        })}
                    </Tabs>
                </AppBar>
                {!isLoading ?
                    sites.length !== 0 && sites ?
                        <div className={classes.tablesContainer} id='tablesContainer' ref={tablesRef}>
                            {sites ?
                                sites.map((site, key) => {
                                    const siteStats = stats.sites.find((object) => object.id === site.id);
                                    const countSiteItems = siteStats ? siteStats[categories[pageParams.category].apiName] : 'No stats';
                                    const percentage = countSiteItems !== 'No stats' ? (countSiteItems / stats.global[categories[pageParams.category].apiName]) * 100 : 'No stats';

                                    if (!site.items.find(item => !!item.associatedItems.find(i => i.supervisorAction === '' || i.supervisorAction === 'NONE')) && !displayDoneRow)
                                        return null;

                                    return (
                                        <div key={key} id={site.name}>
                                            <div className={classes.siteNameContainer}>
                                                <IconButton className={classes.margin} onClick={() => toggleHide(site.id)}>
                                                    {!site.hide ?
                                                        <DownIcon fontSize='small' />
                                                        :
                                                        <RightIcon fontSize='small' />
                                                    }
                                                </IconButton>
                                                <Tooltip
                                                    title={
                                                        <React.Fragment>
                                                            <Typography color='inherit'>
                                                                {site.items.length > 1
                                                                    ? `Ouvrir les ${site.items.length} liens de ${site.name}`
                                                                    : `Ouvrir le lien de ${site.name}`
                                                                }
                                                            </Typography>
                                                        </React.Fragment>
                                                    }
                                                    aria-label='add'
                                                    placement='top'
                                                >
                                                    <IconButton
                                                        onClick={
                                                            () => {
                                                                const urls = site.items.map(i => i.url);
                                                                for (let i = 0; i < urls.length; i++) {
                                                                    if (urls[i]) {
                                                                        setTimeout(function () {
                                                                            Facade.openUrl(urls[i]);
                                                                        }, 400);
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    >
                                                        <FlashOnIcon />
                                                    </IconButton>
                                                </Tooltip>

                                                <p className={classes.siteName}>{site.name + ' (' + site.currency + ', ' + translate.i18n(site.taxMode) + ')'}</p>
                                                <p className={classes.siteInformation}>{percentage === 'No stats' ? countSiteItems : countSiteItems + ' items (' + percentage.toFixed(2) + '%)'}</p>
                                                {site.comment ?
                                                    <div>
                                                        <IconButton aria-describedby={open ? site.name: undefined} style={{ marginLeft: '10px' }} size='small'
                                                            onClick={(e) => {
                                                                handleClick(e);
                                                                setCurrentSite(site.name);
                                                            }}>
                                                            <FeedbackIcon style={{ height: '17px', width: '17px' }} />
                                                        </IconButton>
                                                        <Popover
                                                            id={open(site.name) ? site.name: undefined}
                                                            open={open(site.name)}
                                                            anchorEl={anchorEl}
                                                            onClose={handleClose}
                                                            anchorOrigin={{
                                                                vertical: 'bottom',
                                                                horizontal: 'left',
                                                            }}
                                                        >
                                                            <Typography sx={{ p: 2 }}>{site.comment}</Typography>
                                                        </Popover>
                                                    </div>
                                                    :
                                                    null
                                                }
                                            </div>
                                            <div className={classNames(site.hide && classes.hide)}>
                                                <ControlTowerTable
                                                    displayDoneRow={displayDoneRow}
                                                    site={site}
                                                    changeAction={changeAction}/>
                                            </div>
                                        </div>
                                    );
                                })
                                :
                                null
                            }
                        </div>
                        :
                        <div className={classes.noResultContainer}>No results found</div>
                    :
                    <div className={classes.loadingContainer}>
                        <CircularProgress className={classes.progress} />
                    </div>
                }
                {!isLoading ?
                    sites.length !== 0 && sites ?
                        <Table>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        colSpan={9}
                                        count={count}
                                        rowsPerPage={pageParams.rowsPerPage}
                                        page={page - 1}
                                        rowsPerPageOptions={[10, 25, 50, 100, 250, 1000]}
                                        onPageChange={(event,newPage) => {
                                            setPage(newPage + 1);
                                        }}
                                        onRowsPerPageChange={(event, value) => {
                                            handleChangePageParams('rowsPerPage', value.props.value);
                                        }}
                                        labelDisplayedRows={({ from, to }) => from + '-' + to + ' ' + translate.i18n('OF') + ' ' + count}
                                        labelRowsPerPage={translate.i18n('ROWS_PER_PAGE')}
                                        ActionsComponent={Paginator}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                        : null
                    : null}
            </Paper>
        </div>
    );
};

export default ControlTowerPage;
